import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

export type PillTone = 'success' | 'danger' | 'warn' | 'info' | 'neutral' | 'maroon';

@Component({
  standalone: true,
  selector: 'app-pill',
  imports: [CommonModule],
  template: `
    <span class="pill" [ngClass]="color ? '' : 'pill--' + tone"
          [style.background]="color ? color + '18' : null"
          [style.color]="color || null">
      <span class="pill-dot" *ngIf="dot" [style.background]="color || null"></span>{{ label }}
    </span>
  `,
  styles: [`
    .pill { display: inline-flex; align-items: center; gap: 6px; padding: 4px 11px;
            border-radius: 20px; font-size: 11.5px; font-weight: 700; white-space: nowrap; line-height: 1.4; }
    .pill-dot { width: 6px; height: 6px; border-radius: 50%; background: currentColor; flex-shrink: 0; }
    .pill--success { color: #1f7a4d; background: rgba(31,122,77,.10); }
    .pill--danger  { color: #b00020; background: rgba(176,0,32,.10); }
    .pill--warn    { color: #9a6700; background: rgba(154,103,0,.10); }
    .pill--info    { color: #3a4d8f; background: rgba(58,77,143,.10); }
    .pill--neutral { color: #6b5f63; background: rgba(107,95,99,.10); }
    .pill--maroon  { color: #334155; background: rgba(51,65,85,.10); }
  `],
})
export class PillComponent {
  @Input() label = '';
  @Input() tone: PillTone = 'neutral';
  @Input() dot = false;
  @Input() color: string | null = null;
}
